<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate('', true)"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <div class="card-toolbar" before-btns>
    <!-- numberAggregator -->
    <button
      (click)="getNumberAggregator()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 tw-mr-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="pageVocabs + 'numberAggregator' | translate"
    >
      <i class="mdi mdi-magnify mdi-20px tw-p-0 text-navyBlue"></i>
    </button>

    <!-- validateNumber -->
    <button
      (click)="getIsValidNumber()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 tw-mr-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="pageVocabs + 'isValidNumber' | translate"
    >
      <i class="mdi mdi-cellphone mdi-20px tw-p-0 text-info"></i>
    </button>
  </div>

  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- id -->
        <td>
          <span copyToClipboard>{{
            item?.id | enumToText : SmsAggregatorsEnumValues
          }}</span>
        </td>

        <!-- name -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.name"
          ></td-value>
        </td>

        <!-- title -->
        <td>
          <td-value copyToClipboard [value]="item?.title"></td-value>
        </td>

        <!-- regex -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.regex"
          ></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td
          *ngIf="permissionService.userState()?.organizationId == 1"
          class="sticky-td"
        >
          <a
            (click)="onUpdateRegex(item.id)"
            class="btn btn-sm"
            [matTooltip]="
              formPageConfig.vocabs + 'updateRegexTitle' | translate
            "
          >
            <i
              class="mdi mdi-pencil-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-navyBlue"
            ></i>
          </a>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------- Audit ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
